import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { AIAttributionFooter } from '@atlassian/ai-components';
import { NewContentHistoryAISummaryFooter } from '@confluence/quick-summary';

const footerBoxStyles = xcss({
	borderTop: `${token('border.width')} solid ${token('color.border')}`,
});

const boxTextStyles = xcss({
	color: 'color.text.subtlest',
});

const newContentHistoryBoxTextStyles = xcss({
	marginTop: 'space.800',
	textAlign: 'center',
});

const newContentHistoryStackStyles = xcss({
	height: '100%',
	justifyContent: 'space-between',
});

const i18n = defineMessages({
	diffEmptyBetweenVersionsText: {
		id: 'page-catchup.diff.empty.between.versions.text',
		defaultMessage:
			'These versions are too similar for Atlassian Intelligence (AI) to generate a summary of the differences between them.',
		description:
			'Text to show to the user to indicate that the two selected version are too similar to generate a summary',
	},
});

type VersionDiffEmptyComponentProps = {
	isInNewContentHistory?: boolean;
	contentId: string;
};

export const VersionDiffEmptyComponent = ({
	isInNewContentHistory,
	contentId,
}: VersionDiffEmptyComponentProps) => {
	const intl = useIntl();
	return (
		<Stack xcss={isInNewContentHistory ? newContentHistoryStackStyles : undefined}>
			<Box
				padding="space.250"
				xcss={[boxTextStyles, isInNewContentHistory && newContentHistoryBoxTextStyles]}
			>
				<FormattedMessage {...i18n.diffEmptyBetweenVersionsText} />
			</Box>
			<Box
				testId="ai-attribution-footer"
				paddingInline="space.200"
				paddingBlock="space.050"
				xcss={footerBoxStyles}
			>
				{isInNewContentHistory ? (
					<NewContentHistoryAISummaryFooter
						analyticsProperties={{ source: 'pageCatchup' }}
						contentId={contentId}
						summaryText={intl.formatMessage(i18n.diffEmptyBetweenVersionsText)}
						showBorder={false}
					/>
				) : (
					<AIAttributionFooter />
				)}
			</Box>
		</Stack>
	);
};
